<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card style="border-radius: 1.5em;">
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha inicial</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha final</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <!-- Selector de tipo de servicio -->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereStations">
                <label class="vs-input--label">Estación de pago</label>
                <multiselect v-model="selectedStations" placeholder="Seleccione una estación" label="name"
                             track-by="code" :options="showStations" :multiple="true"
                             :taggable="true" :max-height="150" :max="50">
                </multiselect>
              </vs-col>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button :disabled="!isSearch" @click="listPreview()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button :disabled="!isDownloadable" class="btnx" type="filled" color="danger"
                               @click="downloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <hr class="custom-hr"/>
            <!-- Inicio Panel totales -->
            <vs-card v-if="showTable">
              <div class="d-md-flex align-items-center">
                <div>
                  <h3 class="card-title">Totalidad del recaudo</h3>
                </div>
              </div>
              <vs-row vs-justify="center">
                <vs-col vs-lg="4" vs-xs="12" vs-sm="4">
                  <h1 class="mb-0 mt-4"> {{ totalSold }} </h1>

                  <h4 class="font-weight-light ">Valor total</h4>
                  <h2 class="mb-0 mt-4">{{ totalQuantity }}</h2>
                  <h4 class="font-weight-light ">Total transacciones</h4>
                </vs-col>
                <vs-col vs-lg="8" vs-xs="12" vs-sm="8">
                  <div v-if="showTable">
                    <vs-row class="mt-4">
                      <vs-col
                          vs-xs="12"
                          v-for="(totalBilling, index) in totalsBilling"
                          :key="index"
                          :class="[ totalBilling.gridlg, totalBilling.gridsm ]"
                      >
                        <div class="d-flex align-items-center">
                          <div class="mr-2">
            <span class="display-4" :class="[ totalBilling.iconcolor ]">
              <i :class="[ totalBilling.icon]"></i>
            </span>
                          </div>
                          <div>
                            <span :class="[ totalBilling.textcolor ]">{{ totalBilling.text }}</span>
                            <h3 class="font-medium mb-0">{{ totalBilling.money }}</h3>
                          </div>
                        </div>
                      </vs-col>
                    </vs-row>
                  </div>
                </vs-col>
              </vs-row>
            </vs-card>
            <!-- Fin Panel totales -->
          </vs-card>
        </vs-col>
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <div style="max-height: 40em; border-radius: 1.5em;">
            <vs-card style="border-radius: 1.5em;">
              <h3 class="card-title d-flex">
                Tabla de previsualización
              </h3>
              <vs-table :data="tableData"
                        max-items="50"
                        pagination>
                <template slot="thead">
                  <vs-th sort-key="prefix">Fecha</vs-th>
                  <vs-th sort-key="invoiceNumber">Estación de pago</vs-th>
                  <vs-th sort-key="creationDate">Pago en efectivo</vs-th>
                  <vs-th sort-key="totalConcept">Pago electrónico</vs-th>
                  <vs-th sort-key="methodPay">Número de transacciones</vs-th>
                  <vs-th sort-key="userName">Total recaudo</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].days">
                      {{ data[indextr].days }}
                    </vs-td>
                    <vs-td :data="data[indextr].invoiceNumber">
                      {{data[indextr].nickname ? data[indextr].nickname : data[indextr].nameDevice }}
                    </vs-td>
                    <vs-td :data="data[indextr].cashPay">
                      {{ data[indextr].cashPay }}
                    </vs-td>
                    <vs-td :data="data[indextr].electronicPay">
                      {{ data[indextr].electronicPay }}
                    </vs-td>
                    <vs-td :data="data[indextr].quantity">
                      {{ data[indextr].quantity}}
                    </vs-td>
                    <vs-td :data="data[indextr].finalTotal">
                      {{ data[indextr].finalTotal }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vs-card>
          </div>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import multiselect from "vue-multiselect";
import Treeselect from "@riophae/vue-treeselect";
import DateUtils from "@/global/DateUtils";
import toast from "@/global/ToastConfig";
import bathroomsReportsEndpoints from "@/endpoints/reports/bathrooms-reports/BathroomsReportsEndpoints";
import downloadEndpoint from "@/endpoints/download/downloadEndpoint";
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";
import {renderPropsTotals} from "@/global/utils";

export default {
  name: "bathrooms-collection",
  components: {
    Treeselect,
    CompanySelector,
    multiselect
  },
  data() {
    return {
      totalsBilling: [],
      initialDate: null,
      finalDate: null,
      companyId: null,
      isLoading: false,
      showTable: false,
      tableData: [],
      activePrompt: false,
      page: 1,
      perPage: 50,
      total: 0,
      movementSelected: {},
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      totalPages: 0,
      thereStations: false,
      selectedStations: [],
      showStations: [],
      listStations: [],
      thereMethods: false,
      listMethods: [],
      isSearch: false,
      isDownloadable: false,
      forceRender: 0,
      totalSold: "",
      totalQuantity: null,
    }

  },
  watch: {
    /**
     * Observa el companyId y realiza una accion si este cambia
     */
    companyId() {
      this.isDownloadable = false;
      this.isSearch = false;
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.selectedStations = [];
      this.initialDate = null;
      this.finalDate = null;
      this.validateParams();
    },
    /**
     * Observa el initialDate y realiza una accion si este cambia
     */
    initialDate() {
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.selectedStations = [];
      this.validateParams();
    },
    /**
     * Observa el finalDate y realiza una accion si este cambia
     */
    finalDate() {
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.showMethods = [];
      this.selectedStations = [];
      this.validateParams();
    },
    selectedStations() {
      this.tableData = [];
      this.showTable = false;
    },
    showStations() {
      this.thereStations = this.showStations.length > 0;
    }
  },
  methods: {
    /**
     * Metodo que limpia el formulario inicial
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.showTable = false;
      this.tableData = [];
      this.selectedMethods = [];
      this.selectedStations = [];
      this.page = 1;
      this.isSearch = false;
      this.isDownloadable = false;
      this.totalsBilling = [];
    },
    /**
     * metodo que valida si los parametros  de los servicios de traer los
     * metodos de pago y las estaciones son los correctos si no sale y no los muestra y no ejecuta el servicio
     * @returns {Promise<void>}
     */
    validateParams() {
      this.isLoading = true;
      if (!this.companyId) {
        this.thereStations = false;
        this.isLoading = false;
        return;
      }
      if (!this.finalDate || !this.initialDate) {
        this.thereStations = false;
        this.isLoading = false;
        return;
      }
      this.listDevices();
    },
    /**
     * Metodo que asigna los parametros para descarga y previsualizacion del reporte
     * @returns {{finalDate: string, companyId: null, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
        }),
        payPoints: this.getValidateStations()
      }
    },
    /**
     *  metodo que valida si seleccionaron una estacion o si no que tenga encuenta todas las estaciones
     * @returns {string}
     */
    getValidateStations() {
      return this.selectedStations.length === 0
          ? this.showStations.map(item => item.code).join(",")
          : this.selectedStations.map(item => item.code).join(",")
    },
    /**
     * Metodo que valida mis parametros en la interfaz grafica
     * para no hecer peticiones erroneas al servidor
     * @returns {Promise<void>}
     */
    validateForm() {
      if (!this.finalDate || !this.initialDate) {
        this.isLoading = false;
        throw new Error("Debe seleccionar  la fecha inicial y/o  la fecha final");
      }

      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        this.isLoading = false;
        throw new Error("La fecha final no puede ser inferior a la fecha inicial");
      }
      if (!this.companyId) {
        this.isLoading = false;
        throw new Error("Seleccione una compañia");
      }
    },
    /**
     * Metodo de descarga del reporte por medio de una promesa
     * @returns {Promise<void>}
     */
    downloadReport() {
      try {
        this.isLoading = true;
        toast.info('Cargando reporte');
        this.validateForm();
        const objParams = this.prepareParameters();
        bathroomsReportsEndpoints.downloadCollectionBathrooms(objParams)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              downloadEndpoint.downloadFile(data.info);
              this.isLoading = false;
            })
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * Metodo que genera la previsualizacion de la tabla por medio de una promesa
     * @returns {Promise<void>}
     */
    listPreview() {
      try {
        this.isLoading = true;
        toast.info('Cargando información');
        this.validateForm();
        const objParams = this.prepareParameters();
        bathroomsReportsEndpoints.listCollectionBathrooms(objParams)
            .then(data => {
              if (data.code <= 0) {
                this.isLoading = false;
                return;
              }
              this.tableData = data.info.records;
              this.totalSold = data.info.totalizedTotal;
              this.totalQuantity = data.info.totalizedQuantity
              this.getTotals(data);
              this.showTable = true;
              this.isLoading = false;
            });

      } catch (error) {
        toast.error(error.message);
        this.isLoading = false;
      }
    },
    /**
     * metodo que lista las estaciones que facturaron en el rango de fecha ingresado
     * @returns {Promise<void>}
     */
    listDevices() {
      try {
        this.showStations = [];
        this.validateForm();
        const objParams = this.prepareParameters();
        deviceEndpoint.listByBillingRange(objParams)
            .then(data => {
              if (data.length === 0) {
                this.isLoading = false;
                this.isSearch = false;
                this.isDownloadable = false;
                this.thereStations = false;
                return;
              }
              data.forEach((station) => {
                const unity = {
                  name: station.nickname == null ? station.title : station.nickname,
                  code: station.code,
                };
                this.showStations.push(unity);
                this.isSearch = true;
                this.isDownloadable = true;
                this.thereStations = true;
                this.isLoading = false;
              });
            });
        this.forceRender++;
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * Obtiene los totales de facturación y los enlista para renderizarlos
     * @param objInfo
     */
    getTotals(objInfo) {
      const data = objInfo.info;
      const keys = Object.keys(data);
      const totals = [];

      keys.forEach(key => {
        if (key !== "totalRecords" &&
            key !== "records" &&
            key !== "totalizedTotal" &&
            key !== "totalizedTax" &&
            key !== "totalizedQuantity" &&
            data[key] !== null
        ) {
          totals.push({
            "text": key,
            "money": data[key]
          });
        }
      });
      this.totalsRender(totals);
    },
    /**
     * rederizar los totales de facturación
     * @param totalsList
     */
    totalsRender(totalsList) {
      this.totalsBilling = [];
      this.totalsBilling = totalsList.map(item => ({
        gridlg: "vs-lg-8",
        gridsm: "vs-sm-8",
        iconcolor: renderPropsTotals(item.text).color,
        icon: "mdi " + renderPropsTotals(item.text).icon,
        textcolor: "text-dark",
        text: renderPropsTotals(item.text).title,
        money: item.money
      }));
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>